import React, { useState } from 'react';

export const GetStartedRow = ({ theme, density, icon, title, body, palette, onClick }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};
  const [hovered, setHovered] = useState(false);

  // Default to theme accent if no palette given
  const p = palette || {
    color: c.accent,
    light: c.accentLight,
    bg: c.bgHover || `${c.accent}22`,
    border: c.accent,
    glow: c.accentGlow || `${c.accent}66`,
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (ev) => { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); onClick(); } } : undefined}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: 14,
        background: hovered ? c.bgCardHover : 'rgba(0,0,0,0.2)',
        border: `1px solid ${hovered ? c.accent + '66' : c.borderLight}`,
        borderRadius: e.borderRadiusSm || '6px',
        cursor: onClick ? 'pointer' : 'default',
        marginBottom: density.spacing.itemGap,
        transition: e.transition,
        fontFamily: t.fontFamily,
      }}
    >
      {typeof icon === 'string' ? (
        <div style={{
          width: 40, height: 40,
          background: p.bg,
          border: `1px solid ${p.color}55`,
          borderRadius: e.borderRadiusSm || '6px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
          color: p.light,
          fontSize: '1.1rem',
          boxShadow: hovered ? `0 0 12px ${p.glow}` : 'none',
          transition: e.transition,
        }}>{icon}</div>
      ) : (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>{icon}</div>
      )}
      <div style={{ flex: 1, lineHeight: 1.3 }}>
        <div style={{
          color: c.textPrimary,
          fontWeight: 600,
          fontSize: '0.92rem',
          marginBottom: 2,
        }}>{title}</div>
        <div style={{ color: c.textMuted, fontSize: '0.78rem' }}>{body}</div>
      </div>
      <span style={{ color: hovered ? c.accent : c.textMuted, fontSize: '1.2rem' }}>→</span>
    </div>
  );
};
